Model = require('./Model').default

module.exports = class DataEntry extends Model

    defaults:
        # previously anonymous attributes
        selectedSidebar: null

    get: (key) =>
        if key == "entity"
            throw new Error("No getting a superrecord, yo")
        super(key)



// WEBPACK FOOTER //
// ./app/models/DataEntry.coffee